import React, { useState, useEffect, useCallback } from 'react';
import copy from 'copy-to-clipboard';
import { Toast } from 'antd-mobile';
import { encryptText } from '@/utils/fn';
import { DEFAULT_TEXT } from '../config';
import { reportClick } from '@/utils/report';
import styles from '../index.less';

const handleCopySn = sn => {
  if (!sn) return;
  copy(sn);
  Toast.info('复制成功');
  reportClick({
    page_name: 'intime_monitor_detail',
    button_name: 'copy',
  });
};

const BaseInfo = ({ baseInfo }) => {
  const { sn, group, deviceName, status = 0 } = baseInfo;

  const [enableEncrypt, setEnableEncrypt] = useState(true);
  const [showSN, setShowSN] = useState(sn);

  const getEncryptText = useCallback(() => {
    let encryptSN = DEFAULT_TEXT;
    if (!sn) {
      setShowSN(encryptSN);
      return;
    }
    encryptSN = enableEncrypt ? encryptText(sn, '3*4') : sn;
    setShowSN(encryptSN);
  }, [enableEncrypt, sn]);

  const handlePrivacyMenuClick = () => {
    if (!sn) return;
    getEncryptText();
    setEnableEncrypt(!enableEncrypt);
    reportClick({
      page_name: 'intime_monitor_detail',
      button_name: 'encrypt',
    });
  };

  useEffect(() => {
    getEncryptText();
  }, [getEncryptText]);

  return (
    <div className={styles['monitor-base-info']}>
      <h1 className={`${styles['monitor-base-sn']} ${styles[`status-${status}`]}`}>
        <span>{showSN}</span>
        <span className={styles['monitor-base-menu']}>
          <i className={styles['monitor-base-copy']} onClick={() => handleCopySn(sn)} />
          <i
            className={`${styles['monitor-base-privacy']} ${
              enableEncrypt ? styles['eye-close'] : styles['eye-open']
            }`}
            onClick={handlePrivacyMenuClick}
          />
        </span>
      </h1>
      <p className={styles['base-group-note']}>
        <span className={styles['monitor-device-group']}>{group || DEFAULT_TEXT}</span>
        <span className={styles['monitor-device-note']}>{deviceName || DEFAULT_TEXT}</span>
      </p>
    </div>
  );
};

export default BaseInfo;
